<template>
  <div class="app-main-content">
    <h1>Page not found</h1>
    <RiDmvHome />
  </div>
</template>

<script>
import appConfig from '@/app.config'
import RiDmvHome from "@/components/RiDmvHome";

export default {
  name: 'PageNotFound',
  page: {
    title: `Page Not Found | ${appConfig.shortName}`,
    meta: [
      {
        name: 'description',
        content: 'The page you are looking for does not exist.'
      }
    ]
  },
  components: {
    RiDmvHome,
  }
}
</script>
